import React from 'react'
import {
  Filters,
  FiltersProps,
  FilterInputProps,
  ThematicsSelect,
  PeriodDatePicker
} from '@src/containers/Visualisation/components'
import { ANALYTICS_NATIVE_THEME_CLASSIFIER_DATA } from '../constants'

import * as Styled from './Filters.styled'

const InputComponents: React.FC<FilterInputProps> = ({
  data,
  formValues,
  availableDateRange,
  isFetching,
  handleSelectChange,
  handleDateChange,
  handleOpenThemeClassifierModal
}) => (
  <>
    <ThematicsSelect
      options={data?.theme?.map(({ id, name }) => ({ value: id.toString(), label: name })) ?? []}
      value={formValues.theme}
      isDisabled={isFetching}
      label="theme"
      onChange={handleSelectChange}
      onTooltipLinkClick={handleOpenThemeClassifierModal}
      isAnalytics
    />
    <PeriodDatePicker
      availableDateRange={availableDateRange}
      value={{
        min: formValues.min ? new Date(Number(formValues.min)) : undefined,
        max: formValues.max ? new Date(Number(formValues.max)) : undefined
      }}
      disabled={isFetching}
      onChange={handleDateChange}
      isAnalytics
    />
  </>
)

const NativeAnalyticsFilters: React.FC<FiltersProps> = ({ data, isFetching, fetchData }) => {
  return (
    <Styled.Container
      as={Filters}
      data={data}
      isFetching={isFetching}
      fetchData={fetchData}
      themeClassifierModalData={ANALYTICS_NATIVE_THEME_CLASSIFIER_DATA}
      methodologyModalData={{
        period: 'Собираем данные с июля 2024 года, обновляем ежемесячно',
        placement: <>Более 30&nbsp;000 рекламных публикаций</>,
        analytics: (
          <>
            Анализируем размещения рекламодателей в&nbsp;Telegram-каналах через платформу{' '}
            <Styled.Link href="https://telega.in/" target="_blank" rel="noreferrer">
              Telega.in
            </Styled.Link>
          </>
        ),
        description: (
          <>
            Все метрики внутри тематических категорий рассчитываем по&nbsp;медианным
            значениям,&nbsp;&mdash; стоимость интеграций в&nbsp;отдельных блогах и&nbsp;биржах могут
            от&nbsp;них отличаться
          </>
        )
      }}
      FilterInputs={InputComponents}
    />
  )
}

export default NativeAnalyticsFilters
